import './donut_pie_chart_view.js.coffee';# Added by Script 
import './pie_chart_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.TagsLevelZeroPieChartView extends Monitoring.Views.Charts.DonutPieChartView

  initialize: (@options = {}) =>
    @title = I18n.t('monitoring.dashboard.charts.tags_zero')
    @title_en = I18n.t('monitoring.dashboard.charts.tags_zero', {'locale': 'en'})
    super(@options)
    @uniqueView = false
    @url = '/monitoring/dashboard/charts/tagged_count'
    @ajaxCall(@url, @searchQuery.toJSON(), (response) =>
      @contentsData = response
    )

  updateUniqueView: =>
  	@uniqueView = !@uniqueView

  customOptions: =>
    {
      text: if @updateUniqueView() then  'Unique contents tagged count view' else 'Tags count view'
      onclick: =>
        if @tagsData == undefined
          @tagsData = _.extend({}, @data)
        if @uniqueView
          @data = @contentsData
        else
          @data = @tagsData

        @afterAppend()
    }

  _getOptions: ->
    defaultOptions = new Customer.Reports.PieOptions(
      container: @$el.find('.chart')[0]
      onToggleMaximize: => @toggleMaximize()
      isMaximized: @_settings.maximized
    ).get()

    customOptions = {
      chart:
        type: "pie"
        backgroundColor:'transparent'
      title:
        text: @subTitle
      legend:
        labelFormatter: -> @name
      plotOptions:
        pie:
          borderColor: "rgba(0,0,0,0)"
          point:
            events:
              legendItemClick: @_legendClick
    }

    if @_settings.maximized
      maximizedOptions =
        legend:
          enabled: false
        plotOptions:
          pie:
            dataLabels:
              enabled: true
              distance: 13
              formatter: ->
                if @point.hidden
                  ''
                else
                  if @point.name.substr(@point.name.length-2, @point.name.length) == "%)"
                     @point.name = @point.name.substr(0, @point.name.length - 8)
                  "#{@point.name} #{@y}: #{Math.round(@percentage * 10) / 10}%"
    else
      maximizedOptions = {}

    options = $.extend(true, defaultOptions, customOptions, maximizedOptions)
    options.series = @_series()
    options.tooltip.formatter = @_tooltipFormatter

    custom = @customOptions()
    options.exporting.buttons.contextButton.menuItems.push({ separator: true }, custom) if custom

    return options


  getNewQuery: (event) ->
    query = @searchQuery.deepCopy()
    query.set('tags_node_name', [event.point.name])
    query

  _benchmarkDataFromResponse: () ->
    @dataBenchmark.levels[0]
